import styled from "styled-components";

export const Div = styled.div`
display: flex;
align-items: center;
justify-content: flex-start;
gap: 20px;

`